import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { AutocompleteInput } from 'shouldve-been-mui';

class CountryChecklistElement extends ChecklistElement {

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number) {

        super(elementId, name, itemNumber, sortNumber, EditorType.COUNTRY);
    }

    public buildFormElement(value: string, onChange: (value: string) => Promise<void>, countryAutocompleteOptions: { label: string, id: string, disabled: boolean }[], screenWidth: number): JSX.Element {

        const currentCountryAutocompleteOptions: { label: string, id: string, disabled: boolean }[] = countryAutocompleteOptions;

        if (value !== '' && !countryAutocompleteOptions.map((option: { label: string, id: string, disabled: boolean }) => option.id).includes(value)) { //allows removed options to still be there until changed
            currentCountryAutocompleteOptions.push({
                label: value,
                id: value,
                disabled: true,
            });
        }

        return (
            <React.Fragment key={this.elementId}>
                <AutocompleteInput
                    labelText={this.name}
                    value={value}
                    options={currentCountryAutocompleteOptions}
                    onChange={onChange}
                    width={Math.min(screenWidth * 0.8, 500)}
                    dense={true}
                    limit={500}
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default CountryChecklistElement;